import React, { useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Header, Form, Icon, Table,Button } from "semantic-ui-react";
import { Formik, Field, Form as FormikForm } from "formik";
import complogo from "../../../image/RealBooks_Horizont_Logo.png"
import signupcontentbg from "../../../image/removebg-preview.png"
import verticalLogo from "../../../image/RealBooks_Vertical_Logo.png"
import "../components/compcreate.css"
import {signup_Step_OneSchema} from "../data/model"
import * as select from '../data/selector'
import {saveSignupCompCreateData,gettingOTPCallMain,checkingIfDataSaved,getPasswordValidated,getOTPValidated} from "../data/action";
import Signup_Step_One from "./signUp_Step1"
import Signup_Step_Two from "./signUp_Step2"
import Signup_Step_Three from "./signUp_Step3"
import Signup_Step_Four from "./signUp_Step4"
import { Base64,encode, decode  } from 'js-base64';
import base64 from 'react-native-base64'
import { getHeader,URL_RLB } from "../../../store/path";
import axios from "axios";


const Layout = (props) => {
    const dispatch = useDispatch();
    let steponedisplay = props.curState == 1 ? "" : "none";
    let steptwodisplay = props.curState == 2 ? "" : "none";
    let stepthreedisplay = props.curState == 3 ? "" : "none";
    let stepfourdisplay = props.curState == 4 ? "" : "none";
    let signupFormContainInnerClass = props.curState == 3 ? "signUpFormContainerInner signUpBigFormContainerInnerWidth" : "signUpFormContainerInner";
    /*Step one*/
    const [emailid,setemailid] = useState("");
    const [curEmailerrorClass,setEmailErrorClass] = useState("");
    const [emailConsumedMsg,setEmailConsumedMsg] = useState("");  
    const [emailOnChangeTrigger,setEmailOnChangeTrigger] = useState("");  
    const [customEmailErrorMsg,setcustomEmailErrorMsg] = useState("");
    const [curCaptachaerrorClass,setCaptchaErrorClass] = useState("");
    const captchaRef = useRef(null);
    /*Step one Ends*/
    /*Step two*/
    const [curPwrderrorClass,setPwrdErrorClass] = useState("");
    const [customOtpErrorMsg,setcustomOtpErrorMsg] = useState("");
    const [logintostep,setlogintostep] = useState(false);
    const [pwtolog,setpwtolog] = useState("");
    const [loginWithOtp,setloginWithOtp] = useState(false);
    const [loginWithOtpChkVal,setloginWithOtpChkVal] = useState(false);
    const [verificationOtpval,setverificationOtpval] = useState("");
    /*Step two Ends*/
    /*Step three*/
    const [curNameerrorClass,setcurNameerrorClass] = useState("");
    const [customNameErrorMsg,setcustomNameErrorMsg] = useState("");
    const [curNumbrerrorClass,setcurNumbrerrorClass] = useState("");
    const [customNumbrErrorMsg,setcustomNumbrErrorMsg] = useState("");
    const [curPwerrorClass,setcurPwerrorClass] = useState("");
    const [customPwErrorMsg,setcustomPwErrorMsg] = useState("");
    const [curVerCodeerrorClass,setcurVerCodeerrorClass] = useState("");
    const [customVerCodeErrorMsg,setcustomVerCodeErrorMsg] = useState("");
    const [mobileno,setmobileno] = useState("");
    const [countrymob,setcountrymob] = useState(false);
    /*Step three Ends*/
    /*Step four*/
    const [otpErrorclass,setotpErrorclass] = useState("");
    const [customPwrdErrorMsg,setcustomPwrdErrorMsg] = useState("");
    /*Step four Ends*/
    const loginObj = useSelector(state => select.getLoginObject(state, props));
    const dataByemailId = useSelector(state => select.fetchedSignupCreateDataByEmail(state,props));
    const curOTPSent = useSelector(state => select.sentOTP(state,props));
    const isotpFetching = useSelector(state => select.isotpFetching(state,props));
    const isSaving = useSelector(state => select.isSaving(state,props));
    const isDataAlreadySavedChkObj = useSelector(state => select.getisDataAlreadySavedChkObj(state,props));
    const getvalidatedPWObj = useSelector(state => select.getvalidatedPW(state,props));
    const getvalidatedOTPObj = useSelector(state => select.getvalidatedOTP(state,props));
    useEffect(()=>{
        if(props.curState == 2 && logintostep == false && !loginWithOtpChkVal){
            if(getvalidatedPWObj?.data?.type == "success"){
                if((dataByemailId?.name == null || dataByemailId?.name == "") && isSaving == false){
                    dispatch(saveSignupCompCreateData({
                        data:emailid,
                        curState:1
                    }));
                    // setlogintostep(true);
                }        
                setlogintostep(true);
                setPwrdErrorClass("")
                setcustomPwrdErrorMsg("");
                setcurVerCodeerrorClass("")
                setcustomVerCodeErrorMsg("")
            }else{
                let errormsg = "";
                if(getvalidatedPWObj?.data?.error.length > 0){
                    for(let i=0;i<getvalidatedPWObj?.data?.error.length;i++){
                        errormsg += getvalidatedPWObj?.data?.error[i].error_msg;
                    }
                }
                if(errormsg != ""){
                    setPwrdErrorClass("error")
                    setcustomPwrdErrorMsg(errormsg);
                }
            }
        }else if(props.curState == 2 && dataByemailId == undefined && loginWithOtpChkVal){
            if(getvalidatedOTPObj?.data?.type == "success"){
                if((dataByemailId?.name == null || dataByemailId?.name == "") && isSaving == false){
                    dispatch(saveSignupCompCreateData({
                        data:emailid,
                        curState:1
                    }));
                }        
                setlogintostep(true);
                setPwrdErrorClass("")
                setcustomPwrdErrorMsg("");
                setcurVerCodeerrorClass("")
                setcustomVerCodeErrorMsg("")
            }else{
                let errormsg = "";
                if(getvalidatedOTPObj?.data?.error.length > 0){
                    for(let i=0;i<getvalidatedOTPObj?.data?.error.length;i++){
                        errormsg += getvalidatedOTPObj?.data?.error[i].error_msg;
                    }
                }
                if(errormsg != ""){
                    setcurVerCodeerrorClass("error")
                    setcustomVerCodeErrorMsg(errormsg)
                }
            }
        }
        if((props.curState == 3) && dataByemailId == undefined && isSaving == false){
            dispatch(saveSignupCompCreateData({
                data:emailid,
                curState:1
            }));
        }
        if(props.curState == 3 && dataByemailId?.data != null){
            setlogintostep(true);
        }       
        // console.log("curOTPSent=="+curOTPSent+"=isotpFetching="+isotpFetching+"=props.curState="+props.curState)
        if(emailid != "" && curOTPSent == undefined && isotpFetching==false && (props.curState == 2 || props.curState == 3)){
            // console.log("inside")
            dispatch(gettingOTPCallMain({
                data:emailid,
                curState:1
            }));
        }
        let chooseSecondOrThird = (isDataAlreadySavedChkObj?.type == "error" && isDataAlreadySavedChkObj?.error .length) > 0 ? false : true;
        if(isDataAlreadySavedChkObj!=undefined && props.onbackClick == false){
            if(chooseSecondOrThird){
                if(isDataAlreadySavedChkObj?.type == "error"  && !logintostep){
                    props.setCurState(3);
                }else if(isDataAlreadySavedChkObj?.type == "success" && props.curState==1){
                    props.setCurState(2);
                }else if(logintostep && isSaving == false && dataByemailId!= undefined){
                    props.setLayout(2);
                    if(dataByemailId?.data == null || (dataByemailId?.data?.name != null && dataByemailId?.data?.name != "null" && (dataByemailId?.data?.comp_name == null || dataByemailId?.data?.comp_name == ""))){
                        props.setCurState(5);
                    }else if(dataByemailId?.data == null || (dataByemailId?.data?.comp_name != null && dataByemailId?.data?.comp_name != "null" && (dataByemailId?.data?.state == null || dataByemailId?.data?.state == "" || dataByemailId?.data?.state == "Select State"))){
                        props.setCurState(6);
                    }else if(dataByemailId?.data == null || (dataByemailId?.data?.state != null && dataByemailId?.data?.state != "null" && dataByemailId?.data?.state != "Select State" && (dataByemailId?.data?.currency == null || dataByemailId?.data?.currency == ""))){
                        props.setCurState(7);
                    }else if(dataByemailId?.data == null || (dataByemailId?.data?.currency != null && dataByemailId?.data?.currency != "null" && (dataByemailId?.data?.terms_and_condition == null || dataByemailId?.data?.terms_and_condition == "" || dataByemailId?.data?.terms_and_condition == "0"))){
                        props.setCurState(8);
                    }else if(dataByemailId?.data == null || (dataByemailId?.data?.terms_and_condition == "1")){
                        props.setCurState(9);
                    }
                }
            }else{
                let errorStr = "";
                if(isDataAlreadySavedChkObj?.error.length > 0){
                    for(let i=0;i<isDataAlreadySavedChkObj.error.length;i++){
                        errorStr += isDataAlreadySavedChkObj.error[i].error_msg;
                    }
                    setEmailConsumedMsg(errorStr)
                }
            }
        }
    })
    const saveSignup_Steps_DataMain = (values) => {
        let token = captchaRef.current.getValue();
        let emailRegexStr = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            mobileNoRegStr = /^(\+\d{1,3}[- ]?)?\d{10}$/,
            caps_regx = /([A-Z]+)/g,
            small_regx = /([a-z]+)/g,
            num_regx = /([0-9]+)/g,
            special_regx = /([!@#$_&*]+)/g;
        if(props.curState == 1 && (values.email_id == null || values.email_id == "")){
            setEmailErrorClass("error")
            setcustomEmailErrorMsg("Please provide email id")
        }else if(props.curState == 1 && values.email_id != "" && values.email_id != null && !emailRegexStr.test(values.email_id) && !emailRegexStr.test(values.email_id)){            
            setEmailErrorClass("error")
            setcustomEmailErrorMsg("Please provide valid email id")
        }else if(props.curState == 1 && (token=="")){
            setCaptchaErrorClass("error");
        }else if(props.curState == 2 && pwtolog == "" && verificationOtpval==""){
            if(pwtolog == "" && !loginWithOtpChkVal){
                setPwrdErrorClass("error")
                setcustomPwrdErrorMsg("Please provide password")
            }
            if(verificationOtpval=="" && loginWithOtpChkVal){
                setcurVerCodeerrorClass("error")
                setcustomVerCodeErrorMsg("Please provide verification code")
            }
        }else if(props.curState == 3 && (values.name == null || values.name == "")){
            setcurNameerrorClass("error")
            setcustomNameErrorMsg("Please provide name")
        }else if(props.curState == 3 && (mobileno == "" || mobileno.length < 5)){
            setcurNumbrerrorClass("error")
            setcustomNumbrErrorMsg("Please provide mobile number")
        }else if(props.curState == 3 && values.mobile_no != null && values.mobile_no != "" && !mobileNoRegStr.test(values.mobile_no)){
            setcurNumbrerrorClass("error")
            setcustomNumbrErrorMsg("Please provide valid mobile number")
        }else if(props.curState == 3 && (values.password == null || values.password == "")){
            setcurPwerrorClass("error")
            setcustomPwErrorMsg("Please provide password")
        }else if(props.curState == 3 && values.password != null && values.password != "" && !special_regx.test(values.password)){
            setcurPwerrorClass("error")
            setcustomPwErrorMsg("Password must contain a special character")
        }else if(props.curState == 3 && values.password != null && values.password != "" && !num_regx.test(values.password)){
            setcurPwerrorClass("error")
            setcustomPwErrorMsg("Password must contain a number")
        }else if(props.curState == 3 && values.password != null && values.password != "" && !caps_regx.test(values.password)){
            setcurPwerrorClass("error")
            setcustomPwErrorMsg("Password must contain an upper case character")
        }else if(props.curState == 3 && values.password != null && values.password != "" && !small_regx.test(values.password)){
            setcurPwerrorClass("error")
            setcustomPwErrorMsg("Password must contain an lower case character")
        }else if(props.curState == 3 && (values.verification_code == null || values.verification_code == "")){
            setcurVerCodeerrorClass("error")
            setcustomVerCodeErrorMsg("Please provide verification code")
        }else{
            if(loginWithOtpChkVal){
                if(curOTPSent==true){
                    if((dataByemailId?.name == null || dataByemailId?.name == "") && isSaving == false){
                        dispatch(saveSignupCompCreateData({
                            data:emailid,
                            curState:1
                        }));
                    }  
                    setlogintostep(true);
                    setcurVerCodeerrorClass("")
                    setcustomVerCodeErrorMsg("")
                }else{
                    setcurVerCodeerrorClass("error")
                    setcustomVerCodeErrorMsg("Please provide verification code")
                }
            }
            let newvalue ={...values}
            newvalue.mobile_no = mobileno
            setEmailOnChangeTrigger("")
            props.setonbackClick(false)
            if((props.curState==2 && (pwtolog != "" || verificationOtpval!=""))){
                props.setispwEncrypted(true);
                if(!loginWithOtpChkVal){
                    dispatch(getPasswordValidated({
                        "emailId": values.email_id,
                        "password":pwtolog
                    }))
                }
                else{
                    dispatch(getOTPValidated({
                        "emailId": values.email_id,
                        "otp":verificationOtpval
                    }))
                }
            }
            if(props.curState!=2){
                if(props.curState == 1){
                    setemailid(newvalue.email_id)
                    dispatch(checkingIfDataSaved({
                        data:newvalue.email_id,
                        curState:props.curState
                    }));                        
                }else if(props.curState == 3){
                    let otpValidateData = {
                        "emailId": values.email_id,
                        "otp":verificationOtpval
                    },
                    savingData = {
                        data:newvalue,
                        curState:props.curState
                    }
                    otpvalidationsaveFunc(otpValidateData,savingData)
                }else{
                    dispatch(saveSignupCompCreateData({
                        data:newvalue,
                        curState:props.curState
                    }));
                }
            }
        }
    }
    const otpvalidationsaveFunc = (otpValidateData,savingData) =>{
        let url = URL_RLB+"/login/check/otp"
        axios
            .post(
                url,otpValidateData,getHeader(),{ crossDomain: true }
            ).then( response => {
                if(response.data?.type == "success"){
                    dispatch(saveSignupCompCreateData(savingData));
                }else{
                    setcurVerCodeerrorClass("error")
                    setcustomVerCodeErrorMsg("Please provide correct verification code")
                }
            } ).catch( ( error ) => {
                console.log("otp failure=", error );
            } );
    }
    return (
        <div className="maincontainer">
            <div className="aligncontainer">
                <div className="logocontainer">
                    <img src={complogo} className="compLogImg" />
                </div>
            </div>
            <div className="pageTitle">
                <div className="aligncontainer">
                    <Header as='h2' className="pagetitleText">Registration</Header>
                    <div className="submenucontainer">
                        <Header as='h6' size='tiny' className="submenu">home / registration</Header>
                    </div>
                </div>
            </div>
            <div className="aligncontainer">
                <div className="signUpContainer">
                    <div className="signUpContentContainer">
                        <img src={signupcontentbg} className="signupcontentbgStyle" />
                        <h3 className="signuph3">Experience Speed &amp; Efficacy with RealBooks</h3>
                        <h4 className="signuph4">To learn more, visit <a className="cursorpointer" href="https://realbooks.in/">www.realbooks.in</a></h4>
                    </div>
                    <div className="signUpFormContainer">
                        <div className={signupFormContainInnerClass}>
                        <Formik
                            size="large"
                            initialValues={loginObj}
                            // validationSchema={signup_Step_OneSchema}
                            onSubmit={(values) => saveSignup_Steps_DataMain(values)}
                            render={({
                            handleSubmit,
                            onChange,
                            values,
                            handleChange,
                            errors,
                            }) => (
                                <Form
                                    onSubmit={handleSubmit}
                                    as={FormikForm}
                                    className="CustomeForm"
                                    style={{ marginLeft: "5.25%" }}
                                > 
                                    <Signup_Step_One 
                                        displayparam={steponedisplay} 
                                        emailErrorclass={curEmailerrorClass} 
                                        setEmailErrorClass={setEmailErrorClass}
                                        curCaptachaerrorClass={curCaptachaerrorClass}
                                        setcustomEmailErrorMsg={setcustomEmailErrorMsg}
                                        customEmailErrorMsg={customEmailErrorMsg}
                                        setCaptchaErrorClass={setCaptchaErrorClass}
                                        captchaRef={captchaRef}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        emailConsumedMsg={emailConsumedMsg}
                                        setEmailConsumedMsg={setEmailConsumedMsg}
                                        emailOnChangeTrigger={emailOnChangeTrigger}
                                        setEmailOnChangeTrigger = {setEmailOnChangeTrigger}
                                        emailid = {emailid}
                                        setemailid = {setemailid}
                                    />
                                    <Signup_Step_Two 
                                        displayparam={steptwodisplay}
                                        curPwrderrorClass={curPwrderrorClass}
                                        setPwrdErrorClass={setPwrdErrorClass}
                                        customPwrdErrorMsg={customPwrdErrorMsg}
                                        setcustomPwrdErrorMsg={setcustomPwrdErrorMsg}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        setlogintostep={setlogintostep}
                                        logintostep={logintostep}
                                        pwtolog={pwtolog}
                                        setpwtolog={setpwtolog}
                                        loginWithOtp = {loginWithOtp}
                                        setloginWithOtp = {setloginWithOtp}
                                        loginWithOtpChkVal={loginWithOtpChkVal}
                                        setloginWithOtpChkVal={setloginWithOtpChkVal}
                                        verificationOtpval={verificationOtpval}
                                        setverificationOtpval={setverificationOtpval}
                                        customVerCodeErrorMsg={customVerCodeErrorMsg}
                                        setcustomVerCodeErrorMsg={setcustomVerCodeErrorMsg}
                                        curVerCodeerrorClass={curVerCodeerrorClass}
                                        setcurVerCodeerrorClass={setcurVerCodeerrorClass}
                                        emailid = {emailid}
                                        setemailid = {setemailid}
                                        ispwEncrypted={props.ispwEncrypted}
                                        setispwEncrypted={props.setispwEncrypted}
                                    />
                                    <Signup_Step_Three 
                                        displayparam={stepthreedisplay}
                                        curNameerrorClass={curNameerrorClass}
                                        setcurNameerrorClass={setcurNameerrorClass}
                                        customNameErrorMsg={customNameErrorMsg}
                                        setcustomNameErrorMsg={setcustomNameErrorMsg}
                                        curNumbrerrorClass={curNumbrerrorClass}
                                        setcurNumbrerrorClass={setcurNumbrerrorClass}
                                        customNumbrErrorMsg={customNumbrErrorMsg}
                                        setcustomNumbrErrorMsg={setcustomNumbrErrorMsg}
                                        curPwerrorClass={curPwerrorClass}
                                        setcurPwerrorClass={setcurPwerrorClass}
                                        customPwErrorMsg={customPwErrorMsg}
                                        setcustomPwErrorMsg={setcustomPwErrorMsg}
                                        curVerCodeerrorClass={curVerCodeerrorClass}
                                        setcurVerCodeerrorClass={setcurVerCodeerrorClass}
                                        customVerCodeErrorMsg={customVerCodeErrorMsg}
                                        setcustomVerCodeErrorMsg={setcustomVerCodeErrorMsg}
                                        setverificationOtpval={setverificationOtpval}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        mobileno={mobileno}
                                        setmobileno={setmobileno}
                                        countrymob={countrymob}
                                        setcountrymob={setcountrymob}
                                        curState={props.curState}
                                        selectedCountry={props.selectedCountry}
                                        setselectedCountry={props.setselectedCountry}
                                        selectedCountryId={props.selectedCountryId}
                                        setselectedCountryId={props.setselectedCountryId}
                                    />
                                    <Signup_Step_Four 
                                        displayparam={stepfourdisplay}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        otpErrorclass={otpErrorclass}
                                        setotpErrorclass={setotpErrorclass}
                                        customOtpErrorMsg={customOtpErrorMsg}
                                        setcustomOtpErrorMsg={setcustomOtpErrorMsg}
                                    /> 
                                    <Form.Group widths={2}>
                                        <Button
                                            floated="left"
                                            type="submit"
                                            size="medium"
                                            color="green"
                                            className="btn-next"
                                            style={{ width: "94%", marginTop: "10px" }}
                                        >
                                           {
                                            props.curState == 1 ? "Send Verification Code" : "Verify & Proceed"
                                           } 
                                        </Button>
                                    </Form.Group>
                                </Form>
                                )}
                            ></Formik>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footerContainer">
                <div className="aligncontainer">
                    <Table basic='very'>
                        <Table.Row verticalAlign='top'>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="footerInfo">
                                        <div className="footer-logo-wrap">
                                            <a href="https://realbooks.in/" className="footerLogo">
                                                <img alt="" src={verticalLogo} className="compVerticalLogo" />
                                            </a>
                                        </div>
                                        <a className="socialmediaCom" href="https://www.facebook.com/MyRealbooks/"><Icon name="facebook f" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="https://twitter.com/MyRealbooks"><Icon name="twitter" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="https://www.instagram.com/realbooks.online/?hl=en"><Icon name="instagram" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="https://www.linkedin.com/in/realbooks-online-491b8a156/"><Icon name="linkedin" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="http://bit.ly/RealBooks-YouTube"><Icon name="youtube" className="socialmediaIconCom" /></a>
                                    </div>
                                </div>
                            </Table.Cell>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="h4 footerHeading">Important Links</div>
                                    <ul className="footerLink">
                                        <li><a href="https://login.realbooks.in">Login</a></li>
                                        <li><a href="https://realbooks.in/about/">About</a></li>
                                        <li><a href="https://realbooks.in/features/">Features</a></li>
                                        <li><a href="https://realbooks.in/why-realbooks/">Why RealBooks</a></li>
                                        <li><a href="https://realbooks.in/clients/">Our Clients</a></li>
                                        <li><a href="https://realbooks.in/partners/">Partner with us</a></li>
                                        <li><a href="https://realbooks.in/partners#locatePartner">Locate a Partner</a></li>
                                        <li><a href="https://realbooks.in#price">Pricing</a></li>
                                    </ul>
                                </div>
                            </Table.Cell>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="widget">
                                        <div className="h4 footerHeading">Other links</div>
                                        <ul className="footerLink">
                                            <li><a href="https://realbooks.in/faq/">FAQs</a></li>
                                            <li><a href="https://realbooks.in/video/">Video Tutorials</a></li>
                                            <li><a href="https://realbooks.in/security/">Security</a></li>
                                            <li><a href="https://realbooks.in/privacy-policy/">Privacy Policy</a></li>
                                            <li><a href="https://realbooks.in/terms-and-conditions/">Terms &amp; Conditions</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </Table.Cell>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="contactInfo">
                                        <div className="h4 footerHeading">Contact us</div>
                                        <span className="call"><a href="tel:+91-99108-22099"><Icon name="call" className="contactIconCom" />+91-99108-22099</a></span>
                                        <span className="email"><a href="mailto:support@realbooks.in"><Icon name="mail" className="contactIconCom" />support@realbooks.in</a></span>
                                        <a href="https://realbooks.in/contact.html" className="contactBtn Btn">Send us a message</a>
                                    </div>
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    </Table>
                    <div className="copyrightTxt text-center">
                        <p>© Copyright
                            <script>
                                document.write(+new Date().getFullYear());
                            </script>2023 Adansa Solutions Private Limited. All Rights Reserved
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Layout;